import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { take, map } from 'rxjs';

import { PermissionService, UserPermission } from '@eiq/auth';

export const defaultRoutes = new Map<UserPermission, string>([
  [UserPermission.ManageProjects, '/projects'],
  [UserPermission.ViewProjects, '/projects'],
  [UserPermission.ViewProjectsPrelaunch, '/projects'],
  [UserPermission.ManagePanels, '/panel-members/management'],
  [UserPermission.ManageClients, '/clients']
]);

const getDefaultRoute = (permissions: UserPermission[]): string | null => {
  for (const [permission, route] of defaultRoutes) {
    if (permissions.includes(permission)) {
      return route;
    }
  }

  return null;
};

export const defaultRouteResolver: ResolveFn<string | null> = () => {
  const permissionService = inject(PermissionService);

  return permissionService.permissions$.pipe(
    take(1),
    map((permissions) => getDefaultRoute(permissions))
  );
};
